// Copyright (c) 2018 Deere & Company

import React, {
    Component,
    PropTypes
} from 'react';
import Card from './card';
import {DropTarget} from 'react-dnd';

/* eslint-disable babel/new-cap */

const cardTarget = {
    drop(props, monitor, component) {

        const {id} = props;

        const sourceObj = monitor.getItem();

        if (id !== sourceObj.listId) {

            component.props.onCardPush(sourceObj.card, sourceObj.listId);

        }

        return {
            listId: id
        };

    }
};

function handleMoveCard(dragIndex, hoverIndex, listId) {

    const dragCard = this.list[dragIndex];

    this.onCardMove(dragIndex, hoverIndex, listId, dragCard);

}

function handleRemoveCard(index, sourceListId) {

    this.onCardRemove(index, sourceListId);

}

class Container extends Component {

    render() {

        const {
            canDrop,
            connectDropTarget,
            isOver
        } = this.props;

        const isActive = canDrop && isOver;

        const className = `container ${isActive} ? container-active : container-inactive`;

        return connectDropTarget(
            <div className={className}>
                {this.props.list.map((card, index) =>
                    <Card
                        card={card}
                        idAttribute={this.props.idAttribute}
                        index={index}
                        isDisplayValueMapped={this.props.isDisplayValueMapped}
                        key={card[this.props.idAttribute]}
                        listId={this.props.id}
                        mappingId={this.props.mappingId}
                        mappingTable={this.props.mappingTable}
                        moveCard={this.props::handleMoveCard}
                        removeCard={this.props::handleRemoveCard}
                    />
                )}
            </div>
        );

    }

}

Container.displayName = 'Container';
Container.propTypes = {
    canDrop: PropTypes.bool,
    connectDropTarget: PropTypes.func,
    id: PropTypes.string.isRequired,
    idAttribute: PropTypes.string.isRequired,
    isDisplayValueMapped: PropTypes.bool.isRequired,
    isOver: PropTypes.bool,
    list: PropTypes.array.isRequired,
    mappingId: PropTypes.string,
    mappingTable: PropTypes.arrayOf(PropTypes.object),
    onCardMove: PropTypes.func.isRequired,
    onCardPush: PropTypes.func.isRequired,
    onCardRemove: PropTypes.func.isRequired
};

export default DropTarget('CARD', cardTarget, (connect, monitor) => ({
    canDrop: monitor.canDrop(),
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver()
}))(Container);

/* eslint-enable babel/new-cap */



// WEBPACK FOOTER //
// ./src/shared/components/drag-and-drop/container.js